module.exports = __webpack_public_path__ + "img/edelstahltopf.daf5fc99.webp";